import * as _ from 'lodash';
let speakers;
export function getTranscription(transcription) {
  const section = transcription?.Trans?.Episode?.Section
  speakers = _parseSpeakers(transcription?.Trans?.Speakers?.Speaker)
  // console.log('speakers: ', speakers);
  // console.log("Section: ", section);
  if (Array.isArray(section)) {
    //  handle multiple turns

  } else {
    const {Turn: turns} = section;
    if (Array.isArray(turns)) {
      const phrases = _parseTurns(turns)
      return phrases;
    } else {
      if (turns.Phrase.Token) {
        return [{
          speaker: 'NONE',
          words: _parsePhrases(turns.Phrase)
        }]
      } else {
        const speaker = {
          startTime: turns.attributes.startTime, speakerName: _findSpeaker(turns.attributes.speaker, speakers)
        };
        let words = [];
		let _phrases = turns.Phrase;
		if(!Array.isArray(_phrases)){
			  _phrases = [_phrases];
		}
        _phrases.forEach(phrase => {
		  //console.debug("phrase");		  
		  //console.debug(phrase);
		  let tokens = 	phrase.Token;
          if(!Array.isArray(tokens)){
			  tokens = [tokens];
		  }
		  tokens.forEach(token => {
            const {time, length, data} = token.attributes;
            words = [...words,
              {
                startTime: Number(time),
                endTime: Number(time) + Number(length || 0.5),
                word: data,
                length: Number(length || 0.5)
              }]
          })
        });
        return [{
          speaker,
          words
        }]
      }


    }
  }
}


function _parseTurns(turns) {
  if (Array.isArray(turns)) {
    return turns.map(turn => {
      // console.log('turns is an array ', turn)
      const words = _parsePhrases(turn.Phrase);
      // console.log('[_parseTurns]: ',words);
      // console.log('SPEAKER:', turn.attributes.speaker)
      return {
        speaker: {
          startTime: turn.attributes.startTime, speakerName: _findSpeaker(turn.attributes.speaker, speakers)
        },
        words
      }
    })

  } else {
    // console.log('turns is not an array')
    const words = _parsePhrases(turns.Phrase)
    return {
      speaker: {
        startTime: turns.attributes.startTime, speakerName: _findSpeaker(turns.attributes.speaker, speakers)
      },
      words
    }
  }
  // handle turns
}

function _parsePhrases(phrases) {
  if (Array.isArray(phrases)) {
    // console.log('is phrase array')
    const words = phrases.map(phrase => _parseTokens(phrase.Token))
    return _.flatten(words);
  } else {
    const {Token: token} = phrases;
    return _parseTokens(token)

  }
}

function _parseTokens(token) {
  if (Array.isArray(token)) {
    return token.map(phrase => {
      const {time, length, data} = phrase.attributes;
      return {
        startTime: Number(time),
        endTime: Number(time) + Number(length || 0.5),
        word: data,
        length: Number(length || 0.5)
      }
    })
  } else {
    const {time, length, data} = token.attributes;
    return [{
      startTime: Number(time),
      endTime: Number(time) + Number(length || 0.5),
      word: data,
      length: Number(length || 0.5)
    }]
  }
//  handle phrase
}


function _parseSpeakers(speakers) {
  if (Array.isArray(speakers)) {
    return speakers.map(speaker => ({id: speaker.attributes.id, name: speaker.attributes.name}));
  } else {
    return [{id: speakers.attributes.id, name: speakers.attributes.name}]
  }
}

function _findSpeaker(speaker, speakerList) {
  const spk = speakerList.find(s => s.id === speaker);
  if(spk && !spk.name.startsWith("voce ")){
	return spk;
  }
  //return speakerList.find(s => s.id === speaker) || {id: 'NONE', name: 'UNKNOWN'}
  return {id: 'NONE', name: null}
}